@switch (state) {
  @case (ViewStatus.Loading) {
    @if (loaderTemplate) {
      <ng-container *ngTemplateOutlet="loaderTemplate"></ng-container>
    } @else {
      <article data-testid="loader" class="d-flex flex-column gap">
        <ion-skeleton-text
          [animated]="true"
          style="width: 100%; height: 50px"
        ></ion-skeleton-text>
        <ion-skeleton-text
          [animated]="true"
          style="width: 100%; height: 50px"
        ></ion-skeleton-text>
      </article>
    }
  }
  @case (ViewStatus.Resolved) {
    <ng-content></ng-content>
  }
  @case (ViewStatus.Rejected) {
    <article class="retry">
      <ng-container *ngTemplateOutlet="rejectedTemplate"></ng-container>
      @if (hasRetryButton) {
        <ion-button class="retry-button" (click)="onRetry()">{{
          'common_retryButton' | translate
        }}</ion-button>
      }
    </article>
  }
}
